import { get } from 'lodash';
export var getCommunitiesContext = function (state) {
    return state.communitiesContext;
};
export var getApplicationConfigFromContext = function (communitiesContext, appDefinitionId) { return get(communitiesContext, appDefinitionId, {}); };
export var getApplicationConfig = function (state, appDefinitionId) { return getApplicationConfigFromContext(getCommunitiesContext(state), appDefinitionId); };
//# sourceMappingURL=communities-context-selectors.js.map